<stages-dialog2 #dialog>
	<stages-popup-header [viewedDialog]="dialog" />
	@if (loadingError$ | async; as error) {
		<h1 translate="error.title"></h1>
	}

	<stages-popup-content>
		<stages-loading-error-embeddable [credentialsValid]="true" [loadingError$]="loadingError$" />
	</stages-popup-content>
	<stages-popup-footer [viewedDialog]="dialog" />
</stages-dialog2>
